import React, { useState } from 'react';

const s = {
  page: {
    minHeight: '100vh',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    background: 'var(--offwhite)',
    padding: '24px',
  },
  card: {
    background: '#fff',
    borderRadius: 'var(--radius)',
    boxShadow: 'var(--shadow-lg)',
    padding: '48px 40px',
    width: '100%',
    maxWidth: '400px',
    textAlign: 'center',
  },
  bar: {
    background: 'var(--primary)',
    borderRadius: '6px 6px 0 0',
    padding: '20px 24px',
    marginBottom: '32px',
    margin: '-48px -40px 32px',
    display: 'flex',
    alignItems: 'center',
    gap: '12px',
  },
  logoText: {
    color: '#fff',
    fontFamily: 'var(--font-serif)',
    fontSize: '18px',
    letterSpacing: '0.02em',
  },
  subtitle: {
    color: 'var(--accent)',
    fontSize: '12px',
    letterSpacing: '0.1em',
    textTransform: 'uppercase',
    marginBottom: '8px',
  },
  heading: {
    fontFamily: 'var(--font-serif)',
    fontSize: '22px',
    color: 'var(--dark)',
    marginBottom: '8px',
  },
  hint: {
    fontSize: '14px',
    color: '#8a9ab5',
    marginBottom: '28px',
  },
  input: {
    width: '100%',
    padding: '12px 16px',
    border: '1.5px solid var(--rule)',
    borderRadius: 'var(--radius)',
    fontSize: '15px',
    color: 'var(--text)',
    background: 'var(--offwhite)',
    outline: 'none',
    marginBottom: '16px',
    transition: 'border-color 0.2s',
  },
  btn: {
    width: '100%',
    padding: '13px',
    background: 'var(--primary)',
    color: '#fff',
    border: 'none',
    borderRadius: 'var(--radius)',
    fontSize: '15px',
    fontWeight: 600,
    cursor: 'pointer',
    letterSpacing: '0.02em',
    transition: 'background 0.2s',
  },
  error: {
    color: '#c0392b',
    fontSize: '13px',
    marginTop: '10px',
  },
};

export default function PasswordGate({ password, onSuccess }) {
  const [val, setVal] = useState('');
  const [error, setError] = useState('');
  const [focused, setFocused] = useState(false);

  function attempt() {
    if (val === password) {
      onSuccess();
    } else {
      setError('Incorrect password. Please try again.');
      setVal('');
    }
  }

  return (
    <div style={s.page}>
      <div style={s.card}>
        <div style={s.bar}>
          <div style={s.logoText}>Crafted Capital Co.</div>
        </div>
        <div style={s.subtitle}>Deal Portal</div>
        <h1 style={s.heading}>Welcome back</h1>
        <p style={s.hint}>Enter your access password to continue.</p>
        <input
          type="password"
          placeholder="Password"
          value={val}
          autoFocus
          onChange={e => { setVal(e.target.value); setError(''); }}
          onKeyDown={e => e.key === 'Enter' && attempt()}
          onFocus={() => setFocused(true)}
          onBlur={() => setFocused(false)}
          style={{ ...s.input, borderColor: focused ? 'var(--primary)' : 'var(--rule)' }}
        />
        <button style={s.btn} onClick={attempt}
          onMouseEnter={e => e.target.style.background = 'var(--mid)'}
          onMouseLeave={e => e.target.style.background = 'var(--primary)'}
        >
          Access Portal
        </button>
        {error && <div style={s.error}>{error}</div>}
      </div>
    </div>
  );
}
